import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

const heroMovies = movies.filter(m => m.isHot).slice(0, 4);

export default function HeroBanner() {
  const [current, setCurrent] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const next = useCallback(() => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrent((prev) => (prev + 1) % heroMovies.length);
    setTimeout(() => setIsTransitioning(false), 600);
  }, [isTransitioning]);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const movie = heroMovies[current];

  return (
    <section className="relative h-[420px] md:h-[600px] w-full overflow-hidden">
      <div className="absolute inset-0 bg-background-950">
        {heroMovies.map((m, i) => (
          <img
            key={m.id}
            src={m.backdrop}
            alt={m.title}
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${
              i === current ? 'opacity-100' : 'opacity-0'
            }`}
          />
        ))}
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-background-50"></div>

      <div className="absolute inset-0 flex items-center">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 w-full">
          <div className="max-w-xl">
            <div className="flex items-center gap-2 mb-3">
              <span className="px-2 py-0.5 text-xs font-medium bg-primary-500 text-background-50 rounded whitespace-nowrap">
                {movie.quality}
              </span>
              {movie.isNew && (
                <span className="px-2 py-0.5 text-xs font-medium bg-accent-500 text-background-50 rounded whitespace-nowrap">
                  NEW
                </span>
              )}
              <span className="text-sm text-background-50/80">{movie.year}</span>
              <span className="text-sm text-background-50/80">|</span>
              <span className="flex items-center gap-1 text-sm text-background-50/90">
                <i className="ri-star-fill text-accent-400 text-xs"></i>
                {movie.rating}
              </span>
            </div>

            <h1 className="text-3xl md:text-5xl font-bold font-heading text-background-50 mb-3 leading-tight">
              {movie.title}
            </h1>
            <p className="text-sm md:text-base text-background-50/80 mb-4 line-clamp-2 leading-relaxed max-w-lg">
              {movie.description}
            </p>

            <div className="flex items-center gap-3 flex-wrap">
              <Link
                to={`/detail/${movie.id}`}
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-fill text-lg"></i>
                立即观看
              </Link>
              <Link
                to={`/detail/${movie.id}`}
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-sm hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line text-lg"></i>
                影片详情
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {heroMovies.map((_, i) => (
          <button
            key={i}
            onClick={() => { setCurrent(i); }}
            className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
              i === current ? 'bg-primary-500 w-6' : 'bg-background-50/40 hover:bg-background-50/70'
            }`}
          ></button>
        ))}
      </div>
    </section>
  );
}